/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-17 10:41:29
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-05-10 14:36:23
 * @FilePath: /unifyxp-v2-store-portal/src/config/SiderConfig/MainPageSIderConfig.tsx
 */
/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import React from 'react';

import { Icon } from '@/src/tools/icon';
import {
  reportSubscription,
  reports,
  //dashboard,
  analyticsParent,
  communication,
  auditTrailParent,
  voucher,
  review,
  inventory,
  stockIn,
  product,
  productParent,
  giftCard,
  shoppingCartTemplate,
  subscriptionBuy,
  orders,
  orderParent,
  customerGridParent,
  salesChannelGrid,
  settings,
} from 'src/tools/permissions/storeSiderPermission';
import { EPermissionSource } from 'src/types/common/resources';
import { storeDict } from 'src/tools/urlMap';
import { getI18nFromGeneral } from 'src/tools/tools';
import { replaceI18nVariables } from '@/src/tools/tools';

// import { useRequest } from 'ahooks';
// import { getPendingReviewCount } from 'src/request/review';
// import { get } from 'lodash';

//import { useClearSalesChannel } from 'src/constrains/SalesChannelHOC/useSalesChannel';
// const Test = () => {
//   React.useEffect(() => {
//     useClearSalesChannel();
//   }, []);
//   return <div>Portal 2.0</div>;
// };

export const menuArray = (params, { reviewCount }) => {
  // const isOnProducts = (openKeys || []).includes('products');
  // const { data, cancel, run } = useRequest(() => getPendingReviewCount(), {
  //   //ready: isOnProducts,
  //   pollingInterval: 5000,
  // });
  // React.useEffect(() => {
  //   console.log('123');
  //   if (!isOnProducts) {
  //     cancel();
  //   } else {
  //     run();
  //   }
  // }, [isOnProducts]);
  // const count = get(data, 'data.payload') || 0;
  // console.log('count', count);

  // console.log('menuArray', menuArray);
  // setTimeout(() => {
  //   useClearSalesChannel();
  // });

  return [
    {
      textOnly: true,
      text: 'Portal 2.0',
    },
    // {
    //   path: '/aa',
    //   iconType: <DesktopOutlined />,
    //   name: 'portalBrands',
    //   key: 'nothing',
    //   position: 'top_top',
    //   routers: [],
    // },
    {
      // path: '/',
      // iconType: <Icon type='iconpanel' />,
      // name: 'Homepage',
      // key: 'Homepage',
      // position: 'top_top',
      // routers: ['/'],

      path: '/',
      name: getI18nFromGeneral('general.sider.dashboard'),
      key: 'dashboard',
      iconType: <Icon type='iconpanel' />,
      routers: storeDict.dashboard,
      //source: EPermissionSource.store,
      //permissionGroup: dashboard,
    },
    {
      iconType: <Icon type='iconorders' />,
      name: getI18nFromGeneral('general.sider.orders'),
      key: 'Orders',
      position: 'top_top',
      source: EPermissionSource.store,
      permissionGroup: orderParent,
      sub: [
        {
          path: '/orderList',
          name: getI18nFromGeneral('general.sider.allOrders'),
          key: 'allOrders',
          iconType: undefined,
          source: EPermissionSource.store,
          permissionGroup: orders,
          routers: storeDict.orders, //[('/orderList', '/order/*', 'orderCreate')],
        },
        {
          path: '/order/subscriptionBuy/list',
          name: getI18nFromGeneral('general.sider.subscriptionBuy'),
          key: 'subscriptionBuy',
          iconType: undefined,
          source: EPermissionSource.store,
          permissionGroup: subscriptionBuy,
          routers: [
            '/order/subscriptionBuy/list',
            '/order/subscriptionBuy/edit/*',
          ],
        },
        {
          path: '/order/shoppingCart/list',
          name: getI18nFromGeneral('general.sider.shoppingCartTemplate'),
          key: 'Shopping Cart Template',
          iconType: undefined,
          source: EPermissionSource.store,
          permissionGroup: shoppingCartTemplate,
          routers: storeDict.shoppingCartTemplate, // ['/order/shoppingCart/list', '/order/shoppingCart/edit/*'],
        },
        {
          path: '/order/giftCard/list',
          name: getI18nFromGeneral('general.sider.giftcard'),
          key: 'giftCard',
          iconType: undefined,
          source: EPermissionSource.store,
          permissionGroup: giftCard,
          routers: storeDict.giftCard, //['/order/giftCard/list', '/order/giftCard/edit/*'],
        },
      ],
    },
    {
      iconType: <Icon type='iconproducts' />,
      name: getI18nFromGeneral('general.sider.products'),
      key: 'products',
      position: 'top_top',
      source: EPermissionSource.store,
      permissionGroup: productParent,
      sub: [
        {
          path: '/productsList',
          name: getI18nFromGeneral('general.sider.allProducts'),
          key: 'allProducts',
          iconType: undefined,
          source: EPermissionSource.store,
          permissionGroup: product,
          routers: storeDict.products,
        },

        {
          path: '/stockList',
          iconType: undefined,
          name: getI18nFromGeneral('general.sider.stockIn'),
          key: 'stock',
          source: EPermissionSource.store,
          permissionGroup: stockIn,
          routers: storeDict.stockIn, //['/stockEditor', '/stockList'],
        },
        {
          path: '/inventoryList',
          iconType: undefined,
          name: getI18nFromGeneral('general.sider.inventory'),
          key: 'inventory',
          source: EPermissionSource.store,
          permissionGroup: inventory,
          routers: storeDict.inventory, // ['/inventoryList', '/inventory/*', '/allInventory/*'],
        },
        {
          path: '/reviewList',
          iconType: undefined,
          name: `${replaceI18nVariables(
            getI18nFromGeneral('general.sider.reviews'),
            reviewCount,
          )} `,
          key: 'review',
          source: EPermissionSource.store,
          permissionGroup: review,
          routers: storeDict.reviews, //[('/reviewList', '/review/*')],
        },
      ],
    },
    {
      path: '/storeVoucherList',
      iconType: <Icon type='iconpromotion' className={'icon'} />,
      name: getI18nFromGeneral('general.sider.voucher'),
      key: 'Voucher',
      position: 'top_top',
      source: EPermissionSource.store,
      permissionGroup: voucher,
      routers: storeDict.vouchers, //['/storeVoucherList', '/storeVoucherEdit/*'],
    },
    {
      iconType: <Icon type='iconmarketing' />,
      name: getI18nFromGeneral('general.sider.auditTrail'),
      key: 'auditTrail',
      position: 'top_top',
      source: EPermissionSource.store,
      permissionGroup: auditTrailParent,
      sub: [
        {
          path: '/communicationList',
          name: getI18nFromGeneral('general.sider.communication'),
          key: 'communication',
          iconType: undefined,
          source: EPermissionSource.store,
          permissionGroup: communication,
          routers: storeDict.communications, //['/communicationList'],
        },
      ],
    },
    {
      iconType: <Icon type='iconreport' />,
      name: getI18nFromGeneral('general.sider.analytics'),
      key: 'analytics',
      position: 'top_top',
      source: EPermissionSource.store,
      permissionGroup: analyticsParent,
      sub: [
        {
          path: '/reportSubscriptionList',
          name: getI18nFromGeneral('general.sider.reportSubscription'),
          key: 'reportSubscription',
          iconType: undefined,
          routers: storeDict.reportSubscriptions, //['/reportSubscriptionList'],
          source: EPermissionSource.store,
          permissionGroup: reportSubscription,
        },
        {
          path: '/reportList',
          name: getI18nFromGeneral('general.sider.reports'),
          key: 'reports',
          iconType: undefined,
          routers: storeDict.reports, //['/reportList'],
          source: EPermissionSource.store,
          permissionGroup: reports,
        },
      ],
    },
    {
      textOnly: true,
      // text: 'Portal 2.0',
      splitLine: true,
    },
    {
      path: '/customerDatabase',
      iconType: <Icon type='iconcustomers1' className={'icon'} />,
      name: getI18nFromGeneral('general.sider.customers'),
      key: 'customers',
      position: 'top_top',
      routers: storeDict.customersList, //['/customerDatabase'],
      source: EPermissionSource.store,
      permissionGroup: customerGridParent,
    },
    {
      path: '/salesChannels',
      iconType: <Icon type='iconsaleschannel1' className={'icon'} />,
      name: getI18nFromGeneral('general.sider.salesChannel'),
      key: 'salesChannel',
      position: 'bottom_top',
      routers: storeDict.salesChannels, // ['/salesChannels'],
      source: EPermissionSource.store,
      permissionGroup: salesChannelGrid,
    },
    {
      path: '/settings',
      iconType: <Icon type='iconsettings' className={'icon'} />,
      name: getI18nFromGeneral('general.sider.settings'),
      key: 'settings',
      position: 'bottom_bottom',
      routers: storeDict.settings, //['/settings/*', '/settings'],
      source: EPermissionSource.store,
      permissionGroup: settings,
    },
  ];
};
